import exportFromJSON from "export-from-json";

export const excelParser = () => {
    function exportDataFromJSON(data, newFileName, fileExportType) {
        if (!data) return;
        try {
            const fileName = newFileName || "usage-history";
            const exportType = exportFromJSON.types[fileExportType || "csv"];
            exportFromJSON({ data, fileName, exportType });
        } catch (e) {
            throw new Error("Parsing failed!");
        }
    }

    return {
        exportDataFromJSON
    };
};



// WEBPACK FOOTER //
// ./src/excel-parser.js